/**
 * The organization the public site speaks for (web-app's PublicFooter and support
 * page). Public facts, shown to anyone.
 */
export const SITE = {
  company: '"SHAXZODABONU SHAMSIDDINOVNA" MCHJ',
  inn: '312 042 692',
  phones: ['+998 91 702 72 77', '+998 33 003 66 99'],
  email: 'leonbek2557791@gmail.com',
} as const

export function telHref(phone: string): string {
  return `tel:${phone.replace(/[^\d+]/g, '')}`
}
